import { render, staticRenderFns } from "./PaymentMerchants.vue?vue&type=template&id=5c3aedf5&"
import script from "./PaymentMerchants.vue?vue&type=script&lang=js&"
export * from "./PaymentMerchants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports